import {LitElement, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {connect} from 'pwa-helpers';
import {AttributeInterpreter} from '@viamedici-spc/configurator-ts';

import store from '../../store';
import {hasPimText, pimText} from '../../util/values';
import {setModalActive} from '../../slices/statusSlice';
import {selectSpcConfiguration, selectSpcConfigurations, selectSpcSession, selectSpcSessions} from '../../selectors';
import {generalAttributeOptions} from '../../generalAttributeOptions';

// base class for all attributes
export class SpcBaseAttribute extends connect(store)(LitElement) {
	static styles = css`
		:host {
		}

		.selectedValue {
			color: var(--color-text-widget-value);
			font-size: var(--font-size-widget-small);
			margin-left: auto;
			max-width: 40%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.info {
			font-family: var(--font-family-light);
			color: var(--color-text-widget-value);
			font-size: var(--font-size-widget-small);
			margin-left: auto;
			padding-right: 0;
			background-color: transparent;
			transition: background-color 0.4s, color 0.4s;
			border: none;
			cursor: pointer;
			text-align: right;
		}

		.info:hover {
			color: var(--color-white);
		}
    `;

	@property({type: Object})
	attribute = {};

	@property({type: Boolean})
	hideDisabledValues = false

	@property( {type: String})
	displayStyle = null;

	@property({type: String})
	instance = 'default';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;

		const isDefaultInstance = this.instance === 'default' || this.instance === undefined || this.instance === null;
		this.session = isDefaultInstance ? selectSpcSession(state) : selectSpcSessions(state)[this.instance];
		this.spcConfiguration = isDefaultInstance ? selectSpcConfiguration(state) : selectSpcConfigurations(state)[this.instance];
		this.attributeOptions = generalAttributeOptions[this.attribute.key.replace(/_[0-9]/, '')] || generalAttributeOptions.default;
	}

	hasFeatureDescription() {
		return hasPimText(this.lang, this.attribute.key, 'F.D', this.spcConfiguration, this.translations);
	}
	getFeatureDescription() {
		return pimText(this.lang, this.attribute.key, 'F.D', this.spcConfiguration, this.translations);
	}
	getFirstIncludedChoiceValueId() {
		const includedValues = AttributeInterpreter.getIncludedChoiceValues(this.attribute);
		return includedValues[0]?.id;
	}
	openModal() {
		store.dispatch(setModalActive(
			{
				modalActive: true,
				content: this.getFeatureDescription(),
				title: pimText(this.lang, this.attribute.key, 'F', this.spcConfiguration, this.translations)
			}
		));
	}

	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}
	isMandatory() {
		return AttributeInterpreter.isMandatory(this.attribute);
	}
	getCompareFunction() {
		switch (this.attributeOptions.sort) {
			case 'natural':
				return (a, b) => a.id.localeCompare(b.id, undefined, {
					numeric: true,
					sensitivity: 'base'
				});
			case 'alphanumeric':
				return (a, b) => a.id.localeCompare(b.id);
			case 'custom':
				// position in array this.attributeOptions.customSort
				return (a, b) => {
					const as = this.attributeOptions.customSort.indexOf(a.id);
					const bs = this.attributeOptions.customSort.indexOf(b.id);
					return (as === -1 ? Infinity : as) - (bs === -1 ? Infinity : bs);
				};
			default:
				return (a, b) => 0;
		}
	}

	render() {
	}
}
